import { useQuery } from '@tanstack/react-query'
import { getRecipes } from './recipes.service'

interface UseRecipesOptions {
  search?: string
}

export function useRecipes(options?: UseRecipesOptions) {
  return useQuery({
    queryKey: ['recipes', 'list', options?.search ?? null],
    queryFn: () => getRecipes(options),
  })
}
